import ReportModal, { ReportModalProps } from './ReportModal';

const ReportUserModal = (props: Omit<ReportModalProps, 'kind'>) => (
  <ReportModal {...props} kind="user" />
);

export default ReportUserModal;
